// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import {
  Container,
  Transition,
  Loader,
  Icon,
  Button,
  Grid,
  Popup,
  Image,
  Label,
  Placeholder,
  List
} from 'semantic-ui-react'
import CTA from '../components/CTA'
import fire from '../config/Fire'
import ScrollArea from '@xico2k/react-scroll-area'
import renderHTML from 'react-render-html'
import Img from 'react-image'
import CustomDev from '../components/CustomDev'
import HeroWoo from '../components/HeroWoo'

const ImgLoader = (
  <Placeholder fluid style={{ height: 100 }}>
    <Placeholder.Image />
  </Placeholder>
)

const SingleLoader = (
  <Placeholder fluid style={{ height: 220 }}>
    <Placeholder.Image />
  </Placeholder>
)

class WooCommerce extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      data: [],
      bgColor: '#fff',
      textColor: '#000'
    }
  }

  componentDidMount = () => {
    this.wooAPI()
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({
          loggedIn: true
        })
      } else {
        this.setState({ loggedIn: false })
      }
    })
  }

  wooAPI = (e) => {
    console.log('woo!')
    var url = 'https://murkstomstag.herokuapp.com/api/v1/woo'
    fetch(url)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        console.log(data)
        this.setState({
          data: data,
          done: true,
          singleProduct: false,
          loading: false
        })
      })
      .catch((error) => {
        this.setState({
          error: error.toString(),
          loading: false
        })
      })
  }

  singleProduct = (item, index, e) => {
    console.log(index)
    this.setState({
      done: false,
      index: index,
      singleProduct: true
    })
  }

  goBack = (e) => {
    this.setState({
      done: true,
      singleProduct: false
    })
  }

  render () {
    let { loading, done, error, loggedIn, singleProduct, bgColor, textColor, index } = this.state
    const products = this.state.data.map((item, index) => (
      <List.Item
        as='a'
        key={index}
        className='prod'
        onClick={() => this.singleProduct(index, item)}>
        <Grid verticalAlign='middle'>
          <Grid.Column width={7}>
            <Image
              src={item.images[0].src}
              style={{ width: '100%', resizeMode: 'contain' }}
              alt='featured-media'
            />
          </Grid.Column>
          <Grid.Column width={9}>
            {item.on_sale && (
              <Label size='small'>
                <Icon name='tag' />
                ON SALE!
              </Label>
            )}
            {/* <h6>{item.categories[0].name}</h6> */}
            <h4>{item.name}</h4>
            <h3>
              <b>${item.price}</b>
            </h3>
          </Grid.Column>
        </Grid>
      </List.Item>
    ))
    return (
      <div>
        <HeroWoo />
        <Container className='masterdiv'>
          <Grid
            reversed='mobile'
            stackable
            className='mtb'
            style={{ minHeight: '100vh' }}
            verticalAlign='middle'>
            <Grid.Column width={8}>
              <div className='mt'>
                <p>
                  No configuration needed. Simply copy/paste your API Keys and get your app built
                  and deployed to app store in less than 24h. Need a custom feature?{' '}
                  <a href='contact' style={{ color: 'blue' }}>
                    Get in touch
                  </a>
                </p>
                {!loggedIn && <CTA />}
                <h4>Limitations</h4>
                <p>
                  We try to handle as much of the complexity of building native apps for you as we
                  can. There are cases where this software constraints may not be appropriate for
                  your project. The following is a list of limitations:
                </p>
                <li>
                  The payments are processed on a webview container because of the sensitive nature
                  of the data. Multiple items selection and cart integration are available on the
                  app but not showcased on this protoype.
                </li>
                <li>The minimum supported OS versions are Android 5+ and iOS 10+</li>

                <br />
                <p>
                  Data source:{' '}
                  <a style={{ color: 'blue' }} href='https://dev-woorestapi.pantheonsite.io/'>
                    https://dev-woorestapi.pantheonsite.io/
                  </a>
                </p>
              </div>
            </Grid.Column>
            <Grid.Column width={8}>
              <div className='newframe'>
                <div className='newframe-content'>
                  <div className='containerX' />
                  <div className='newframe-content-body'>
                    {loading && (
                      <div className='mt'>
                        <Loader indeterminate active inline='centered'>
                          Loading...
                        </Loader>
                      </div>
                    )}
                    {error && (
                      <div className='mt'>
                        <p>{error.toString()}</p>
                      </div>
                    )}

                    {done && !error && !singleProduct && (
                      <div className='center mbs'>
                        <h3>DemoShop</h3>
                      </div>
                    )}
                    {singleProduct && !loading && !error && !done && (
                      <div className='cursor' style={{ margin: '14px' }}>
                        <Icon name='angle left' size='large' onClick={this.goBack} />
                      </div>
                    )}

                    {done && (
                      <div style={{ height: '560px', overflow: 'hidden' }}>
                        <ScrollArea trackHidden={true} className='disable-scrollbars'>
                          <List
                            link
                            style={{
                              margin: 7
                            }}>
                            {products}
                          </List>
                        </ScrollArea>
                      </div>
                    )}
                    <Transition visible={singleProduct} animation='fade up' duration={600}>
                      <div>
                        {singleProduct && !loading && !error && !done && (
                          <div
                            className='disable-scrollbars'
                            style={{
                              overflow: 'hidden',
                              height: '560px',
                              color: textColor
                            }}>
                            <ScrollArea trackHidden={true}>
                              <Img
                                decode={false}
                                src={index.images[0].src}
                                loader={SingleLoader}
                                style={{
                                  width: '100%',
                                  resizeMode: 'cover',
                                  minHeight: 200,
                                  margin: 0
                                }}
                                alt='featured-media'
                                unloader={ImgLoader}
                              />
                              <div
                                style={{
                                  padding: 14,
                                  backgroundColor: '#fff',
                                  marginTop: 0,
                                  color: textColor
                                }}>
                                {index.on_sale && (
                                  <div className='mbs'>
                                    <Label size='large' attached>
                                      ON SALE!
                                    </Label>
                                  </div>
                                )}

                                <Grid verticalAlign='middle'>
                                  <Grid.Column floated='left' width={5}>
                                    <h2>{index.name}</h2>
                                  </Grid.Column>
                                  <Grid.Column floated='right' width={5}>
                                    <div className='sameLine'>
                                      {index.on_sale && (
                                        <p
                                          style={{
                                            textDecoration: 'line-through',
                                            fontWeight: '300'
                                          }}>
                                          ${index.regular_price}
                                        </p>
                                      )}
                                      <h3> ${index.price}</h3>
                                    </div>
                                  </Grid.Column>
                                </Grid>
                                {/* <h6>{moment(index.date_created, 'YYYYMMDD').format('ll')}</h6> */}
                              </div>
                              <div
                                style={{
                                  outline: 'none',
                                  margin: 14,
                                  flex: 1,
                                  height: '100%',
                                  backgroundColor: 'transparent',
                                  color: textColor
                                }}>
                                {renderHTML(index.description)}
                                <h5 className='mtbs'>
                                  <b>Category:</b> {index.categories[0].name}{' '}
                                </h5>

                                <Button
                                  style={{
                                    backgroundColor: '#fff',
                                    border: '2px solid #ddd'
                                  }}
                                  fluid>
                                  Add to cart
                                </Button>
                              </div>
                            </ScrollArea>
                          </div>
                        )}
                      </div>
                    </Transition>
                  </div>
                </div>
              </div>
              <br />
              <center>
                <Popup
                  position='bottom center'
                  trigger={
                    <h5>
                      <b>
                        Experimental Preview <Icon name='exclamation triangle' color='yellow' />
                      </b>
                    </h5>
                  }>
                  Rendering of React Native components in a web browser is an experimental feature
                  and may contain issues.
                </Popup>
              </center>
            </Grid.Column>
          </Grid>
          <br />
          <CustomDev />
        </Container>
      </div>
    )
  }
}

export default WooCommerce